export const translation = {
  zenit: {
    en: {
      siteTitle: "Lucky Accumulator",
      rulesBtnText: "Rules",
      title: "Lucky \n" +
      "Accumulator",
      subtitle: "Get 20% of the bet amount with a free bet",
      button: "Collect",
      stepTitle1: 'step 1',
      step1Span1: 'Register\u00A0',
      stepText1: `or\u00A0`,
      stepSpanA: 'log in',
      stepTitle2: 'step 2',
      stepText2: `Collect the accumulators with\u00A0at least 5 events with 3,5+ odd`,
      stepTitle3: 'step 3 ',
      stepText3: `Catch 20% of the bet amount with a free bet`,
      bkString: "Bookmaker Zenit",
      rightString: "All rights reserved",
      supportText: "Support service:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Terms and conditions of the Promotion ",
      paragraph1: '1. The Promotion is held from 15.06.2022 to 01.07.2022.',
      paragraph2: '2. The dates of the Promotion are determined by Zenit Bookmaker and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. A participant must register or log in at zenitbet.com during the Promotion period and press the “PARTICIPATE” button.',
      paragraph4: '4. To receive a free bet, a Participant must:',
      paragraph5: '5. After the calculation of an accumulator, 20% of the bet amount will be credited to the participant\'s account in the form of a free bet, but no more than 850 $ per  accumulator.',
      paragraph6: '6. Bets calculated with the "canceled" status, live tennis bets and stats betting do not count towards the promotion. ',
      paragraph7: '7. To get the free bet, the accumulator bet must be calculated no later than 01.07.2022.',
      paragraph8: '8. Free bets are awarded daily from 00:00 to 03:00 UTC+3.',
      paragraph9: '9. Bonuses are not credited in the following cases:',
      paragraph10: '10. BK Zenit has the right to refuse to charge a free bet to a participant of the Promotion, as well as to suspend a participant from participating in any company\'s Promotions, invalidate any actions of a participant in respect of whom BK Zenit has reasonable suspicions that he knowingly unfairly exercises the rights to participate in the Promotion or abuses them, distorts data or benefits from any forgery of data necessary to participate in the Promotion, including, but not limited to the following actions:',
      paragraph11: '11. In case of detection of any of the violations of the rules of the Promotion, BK Zenit has the right to prohibit the participant from receiving free bets, cancel the winnings received using free bets and block the account of the participant of the Promotion.',
      paragraph12: '12. Terms of use of free bets:',
      paragraph13: '13. In case of winning a bet paid with the amount of the free bet, the participant of the Promotion is paid only the amount of the winnings without taking into account the amount of the free bet. The free bet is not reused.',
      paragraph14: '14. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph15: '15. Use of the free bet implies full agreement of the participant of the Promotion with these rules.',
      tableLeftTopText: 'minimum',
      tableCenterTopText: 'maximum',
      tableRightTopText:  'currency',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph41: "4.1 Combine the accumulator bet with at least 5 events",
      subParagraph42: "4.2 The minimum odds of the  accumulator should not be less than 3.5.",
      subParagraph43: "4.3 The minimum bet amount is 2 $.",
      subParagraph91: "9.1. The bet violates the rules of the Promotion.",
      subParagraph92: "9.2. The bet is made using the free bet.",
      subParagraph93: "9.3. The bet has already been accounted for in other Promotions of the company.",
      subParagraph94: "9.4. The bet was cashed out by the participant of the Promotion.",
      subParagraph101: "a) The participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for BK Zenit and for other participants and for third parties;",
      subParagraph102: "b) in case of revealing the fact that the participant has provided information that does not correspond to reality;",
      subParagraph103: "c) the Participant has violated the Terms and conditions of the Promotion;",
      subParagraph104: "d) the Participant has violated the gambling rules and/or any other rules in effect;",
      subParagraph105: "e) the Participant's account has been blocked.",
      subParagraph121: "12.1. The free bet can be used after verification of compliance with the conditions specified in clause 5 of these Rules, within 7 days.",
      subParagraph122: "12.2. Free bet is available for use only on the entire amount of the free bet.",
      subParagraph123: "12.3. Free bet can only be used in an accumulator with at least 3 events.",
      subParagraph124: "12.4. The odds for each event in the accumulator must be at least 1.5",
      subParagraphLetter71: 'a) The participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for BK Zenit and for other participants and for third parties;',
      subParagraphLetter72: 'b) in case of revealing the fact that the participant has provided information that does not correspond to reality;',
      subParagraphLetter73: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraphLetter74: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraphLetter75: "e) the Participant's account has been blocked."
    },
    ru: {
      siteTitle: "Везучий Экспресс",
      rulesBtnText: "Правила",
      title: "Везучий экспресс",
      subtitle: "Получи +20% к своей ставке фрибетом",
      button: "Собрать",
      stepTitle1: 'шаг 1',
      step1Span1: 'Регистрируйся\u00A0',
      stepText1: 'или\u00A0',
      stepSpanA: 'Авторизуйся',
      step1Span2: '\u00A0на сайте',
      stepTitle2: 'шаг 2',
      stepText2: `Собирай экспресс от 5 событий 
      с общим кэфом не ниже 3.5`,
      stepTitle3: 'шаг 3',
      stepText3: `Лови 20% от суммы 
      ставки фрибетом`,
      bkString: "Букмекерская контора Зенит",
      rightString: "Все права защищены",
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 15.06.2022 г. по 01.07.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК Зенит и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zenitbet.com и нажать кнопку УЧАСТВОВАТЬ.',
      paragraph4: '4. Для получения фрибета Участник должен:',
      paragraph5: '5. После расчета экспресса на счет участника начисляется 20% от суммы ставки в виде фрибета, но не более 50 000 рублей за один экспресс. ',
      paragraph6: '6. В зачет Акции не идут ставки, рассчитанные со статусом «возврат», а также ставки на теннис в режиме live и ставки на статистику.',
      paragraph7: '7. Для получения фрибета экспресс-ставка должна быть рассчитана не позднее 01.07.2022.',
      paragraph8: '8. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      paragraph9: '9. Бонусы не начисляются в следующих случаях:',
      paragraph10: '10. БК Зенит  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК Зенит возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph11: '11. В случае обнаружения любого из нарушений правил Акции БК Зенит  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph12: '12. Условия использования фрибетов:',
      paragraph13: '13. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph14: '14. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph15: '15. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'минимум',
      tableCenterTopText: 'максимум',
      tableRightTopText:  'валюта',
      tableCurrencyRUB: 'рубль',
      tableCurrencyUSD: 'доллар',
      tableCurrencyEUR: 'евро',
      tableCurrencyUAH: 'гривна',
      tableCurrencyKZT: 'тенге',
      tableCurrencyPRB: 'руб. ПМР',
      tableCurrencyIRR: 'иранский риал',
      tableCurrencyBRL: 'бразильский реал',
      tableCurrencyTMT: 'туркменский манат',
      tableCurrencyMDL: 'молдавский лей',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph41: "4.1 Собрать экспресс-ставку от 5 событий.",
      subParagraph42: "4.2 Минимальный коэффициент экспресса должен быть не ниже 3.5.",
      subParagraph43: "4.3 Минимальная сумма ставки 100 рублей.",
      subParagraph91: "9.1. Ставка сделана с нарушением правил Акции.",
      subParagraph92: "9.2. Ставка сделана с использованием бесплатной ставки.",
      subParagraph93: "9.3. Ставка уже была учтена в других акциях компании.",
      subParagraph94: "9.4. Ставка была продана участником Акции. ",
      subParagraph101: "а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК Зенит , так и для иных участников и для третьих лиц;",
      subParagraph102: "б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;",
      subParagraph103: "в) участник нарушает Правила Акции;",
      subParagraph104: "г) участник Акции нарушает Правила азартной игры и/или иные установленные правила",
      subParagraph105: "д) аккаунт участника Акции заблокирован.",
      subParagraph121: "12.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.",
      subParagraph122: "12.2. Использовать можно только полную сумму фрибета.",
      subParagraph123: "12.3. Использовать фрибет можно только на экспресс от 3 событий.",
      subParagraph124: "12.4. Коэффициент каждого события в экспрессе должен быть не ниже 1.5.",
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК Зенит , так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.'
    },
  },
  zenbet: {
    en: {
      siteTitle: "Lucky Accumulator",
      rulesBtnText: "Rules",
      title: `Lucky
       
      Accumulator`,
      subtitle: "Get 20% of the bet amount with a free bet",
      button: "Collect",
      stepTitle1: 'step 1',
      step1Span1: 'Register\u00A0',
      stepText1: `or\u00A0`,
      stepSpanA: 'log in',
      stepTitle2: 'step 2',
      stepText2: `Collect the accumulators with\u00A0at least 5 events with 3,5+ odd`,
      stepTitle3: 'step 3 ',
      stepText3: `Catch 20% of the bet amount with a free bet`,
      bkString: " Bookmaker Zenbet",
      rightString: "All rights reserved",
      supportText: "Email:",
      supportSpan: "support@zen.bet",
      rulesHeaderText: "Terms and conditions of the Promotion ",
      paragraph1: '1. The Promotion is held from 15.06.2022 to 01.07.2022.',
      paragraph2: '2. The dates of the Promotion are determined by Zenbet Bookmaker and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. A participant must register or log in at zen.bet during the Promotion period and press the “PARTICIPATE” button.',
      paragraph4: '4. To receive a free bet, a Participant must:',
      paragraph5: '5. After the calculation of an accumulator, 20% of the bet amount will be credited to the participant\'s account in the form of a free bet, but no more than 850 $ per  accumulator.',
      paragraph6: '6. Bets calculated with the "canceled" status, live tennis bets and stats betting do not count towards the promotion. ',
      paragraph7: '7. To get the free bet, the accumulator bet must be calculated no later than 01.07.2022.',
      paragraph8: '8. Free bets are awarded daily from 00:00 to 03:00 UTC+3.',
      paragraph9: '9. Bonuses are not credited in the following cases:',
      paragraph10: '10. BK Zenbet has the right to refuse to charge a free bet to a participant of the Promotion, as well as to suspend a participant from participating in any company\'s Promotions, invalidate any actions of a participant in respect of whom BK Zenbet has reasonable suspicions that he knowingly unfairly exercises the rights to participate in the Promotion or abuses them, distorts data or benefits from any forgery of data necessary to participate in the Promotion, including, but not limited to the following actions:',
      paragraph11: '11. In case of detection of any of the violations of the rules of the Promotion, BK Zenbet has the right to prohibit the participant from receiving free bets, cancel the winnings received using free bets and block the account of the participant of the Promotion.',
      paragraph12: '12. Terms of use of free bets:',
      paragraph13: '13. In case of winning a bet paid with the amount of the free bet, the participant of the Promotion is paid only the amount of the winnings without taking into account the amount of the free bet. The free bet is not reused.',
      paragraph14: '14. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph15: '15. Use of the free bet implies full agreement of the participant of the Promotion with these rules.',
      tableLeftTopText: 'minimum',
      tableCenterTopText: 'maximum',
      tableRightTopText:  'currency',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph41: "4.1 Combine the accumulator bet with at least 5 events",
      subParagraph42: "4.2 The minimum odds of the  accumulator should not be less than 3.5.",
      subParagraph43: "4.3 The minimum bet amount is 2 $.",
      subParagraph91: "9.1. The bet violates the rules of the Promotion.",
      subParagraph92: "9.2. The bet is made using the free bet.",
      subParagraph93: "9.3. The bet has already been accounted for in other Promotions of the company.",
      subParagraph94: "9.4. The bet was cashed out by the participant of the Promotion.",
      subParagraph101: "a) The participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for BK Zenit and for other participants and for third parties;",
      subParagraph102: "b) in case of revealing the fact that the participant has provided information that does not correspond to reality;",
      subParagraph103: "c) the Participant has violated the Terms and conditions of the Promotion;",
      subParagraph104: "d) the Participant has violated the gambling rules and/or any other rules in effect;",
      subParagraph105: "e) the Participant's account has been blocked.",
      subParagraph121: "12.1. The free bet can be used after verification of compliance with the conditions specified in clause 5 of these Rules, within 7 days.",
      subParagraph122: "12.2. Free bet is available for use only on the entire amount of the free bet.",
      subParagraph123: "12.3. Free bet can only be used in an accumulator with at least 3 events.",
      subParagraph124: "12.4. The odds for each event in the accumulator must be at least 1.5",
      subParagraphLetter71: 'a) The participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for BK Zenbet and for other participants and for third parties;',
      subParagraphLetter72: 'b) in case of revealing the fact that the participant has provided information that does not correspond to reality;',
      subParagraphLetter73: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraphLetter74: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraphLetter75: "e) the Participant's account has been blocked."
    },
    ru: {
      siteTitle: "Везучий Экспресс",
      rulesBtnText: "Правила",
      title: "Везучий экспресс",
      subtitle: "Получи +20% к своей ставке фрибетом",
      button: "Собрать",
      stepTitle1: 'шаг 1',
      step1Span1: 'Регистрируйся\u00A0',
      stepText1: 'или\u00A0',
      stepSpanA: 'Авторизуйся',
      step1Span2: '\u00A0на сайте',
      stepTitle2: 'шаг 2',
      stepText2: `Собирай экспресс от 5 событий 
      с общим кэфом не ниже 3.5`,
      stepTitle3: 'шаг 3',
      stepText3: `Лови 20% от суммы 
      ставки фрибетом`,
      bkString: "Букмекерская контора Zenbet",
      rightString: "Все права защищены",
      supportText: "Email:",
      supportSpan: "support@zen.bet",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 15.06.2022 г. по 01.07.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК Zenbet и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zen.bet и нажать кнопку УЧАСТВОВАТЬ.',
      paragraph4: '4. Для получения фрибета Участник должен:',
      paragraph5: '5. После расчета экспресса на счет участника начисляется 20% от суммы ставки в виде фрибета, но не более 50 000 рублей за один экспресс. ',
      paragraph6: '6. В зачет Акции не идут ставки, рассчитанные со статусом «возврат», а также ставки на теннис в режиме live и ставки на статистику.',
      paragraph7: '7. Для получения фрибета экспресс-ставка должна быть рассчитана не позднее 01.07.2022.',
      paragraph8: '8. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      paragraph9: '9. Бонусы не начисляются в следующих случаях:',
      paragraph10: '10. БК Zenbet  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК Zenbet возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph11: '11. В случае обнаружения любого из нарушений правил Акции БК Zenbet  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph12: '12. Условия использования фрибетов:',
      paragraph13: '13. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph14: '14. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph15: '15. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'минимум',
      tableCenterTopText: 'максимум',
      tableRightTopText:  'валюта',
      tableCurrencyRUB: 'рубль',
      tableCurrencyUSD: 'доллар',
      tableCurrencyEUR: 'евро',
      tableCurrencyUAH: 'гривна',
      tableCurrencyKZT: 'тенге',
      tableCurrencyPRB: 'руб. ПМР',
      tableCurrencyIRR: 'иранский риал',
      tableCurrencyBRL: 'бразильский реал',
      tableCurrencyTMT: 'туркменский манат',
      tableCurrencyMDL: 'молдавский лей',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph41: "4.1 Собрать экспресс-ставку от 5 событий.",
      subParagraph42: "4.2 Минимальный коэффициент экспресса должен быть не ниже 3.5.",
      subParagraph43: "4.3 Минимальная сумма ставки 100 рублей.",
      subParagraph91: "9.1. Ставка сделана с нарушением правил Акции.",
      subParagraph92: "9.2. Ставка сделана с использованием бесплатной ставки.",
      subParagraph93: "9.3. Ставка уже была учтена в других акциях компании.",
      subParagraph94: "9.4. Ставка была продана участником Акции. ",
      subParagraph101: "а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК Zenbet , так и для иных участников и для третьих лиц;",
      subParagraph102: "б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;",
      subParagraph103: "в) участник нарушает Правила Акции;",
      subParagraph104: "г) участник Акции нарушает Правила азартной игры и/или иные установленные правила",
      subParagraph105: "д) аккаунт участника Акции заблокирован.",
      subParagraph121: "12.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.",
      subParagraph122: "12.2. Использовать можно только полную сумму фрибета.",
      subParagraph123: "12.3. Использовать фрибет можно только на экспресс от 3 событий.",
      subParagraph124: "12.4. Коэффициент каждого события в экспрессе должен быть не ниже 1.5.",
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК Zenbet , так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.'
    },
  },
  cupis: {
    ru: {
      siteTitle: "Везучий Экспресс",
      rulesBtnText: "Правила",
      title: "Везучий экспресс",
      subtitle: "Получи +20% к своей ставке фрибетом",
      button: "Собрать",
      stepTitle1: 'шаг 1',
      step1Span1: 'Регистрируйся\u00A0',
      stepText1: 'или\u00A0',
      stepSpanA: 'Авторизуйся',
      step1Span2: '\u00A0на сайте',
      stepTitle2: 'шаг 2',
      stepText2: `Собирай экспресс от 5 событий 
      с общим кэфом не ниже 3.5`,
      stepTitle3: 'шаг 3',
      stepText3: `Лови 20% от суммы 
      ставки фрибетом`,
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-55-50",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 15.06.2022 г. по 01.07.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zenit.win и нажать кнопку УЧАСТВОВАТЬ.',
      paragraph4: '4. Для получения фрибета Участник должен:',
      paragraph5: '5. После расчета экспресса на счет участника начисляется 20% от суммы ставки в виде фрибета, но не более 50 000 рублей за один экспресс. ',
      paragraph6: '6. В зачет Акции не идут ставки, рассчитанные со статусом «возврат», а также ставки на теннис в режиме live и ставки на статистику.',
      paragraph7: '7. Для получения фрибета экспресс-ставка должна быть рассчитана не позднее 01.07.2022.',
      paragraph8: '8. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      paragraph9: '9. Бонусы не начисляются в следующих случаях:',
      paragraph10: '10. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph11: '11. В случае обнаружения любого из нарушений правил Акции БК Зенит  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph12: '12. Условия использования фрибетов:',
      paragraph13: '13. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph14: '14. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph15: '15. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'минимум',
      tableCenterTopText: 'максимум',
      tableRightTopText:  'валюта',
      tableCurrencyRUB: 'рубль',
      tableCurrencyUSD: 'доллар',
      tableCurrencyEUR: 'евро',
      tableCurrencyUAH: 'гривна',
      tableCurrencyKZT: 'тенге',
      tableCurrencyPRB: 'руб. ПМР',
      tableCurrencyIRR: 'иранский риал',
      tableCurrencyBRL: 'бразильский реал',
      tableCurrencyTMT: 'туркменский манат',
      tableCurrencyMDL: 'молдавский лей',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph41: "4.1 Собрать экспресс-ставку от 5 событий.",
      subParagraph42: "4.2 Минимальный коэффициент экспресса должен быть не ниже 3.5.",
      subParagraph43: "4.3 Минимальная сумма ставки 100 рублей.",
      subParagraph91: "9.1. Ставка сделана с нарушением правил Акции.",
      subParagraph92: "9.2. Ставка сделана с использованием бесплатной ставки.",
      subParagraph93: "9.3. Ставка уже была учтена в других акциях компании.",
      subParagraph94: "9.4. Ставка была продана участником Акции. ",
      subParagraph101: "а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и для третьих лиц;",
      subParagraph102: "б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;",
      subParagraph103: "в) участник нарушает Правила Акции;",
      subParagraph104: "г) участник Акции нарушает Правила азартной игры и/или иные установленные правила",
      subParagraph105: "д) аккаунт участника Акции заблокирован.",
      subParagraph121: "12.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.",
      subParagraph122: "12.2. Использовать можно только полную сумму фрибета.",
      subParagraph123: "12.3. Использовать фрибет можно только на экспресс от 3 событий.",
      subParagraph124: "12.4. Коэффициент каждого события в экспрессе должен быть не ниже 1.5.",
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.'
    },
  }
}
